<div class="tabs is-boxed">
  <ul>
    @for (tab of tabs; track tab; let i = $index) {
      <li (click)="selectTab(tab)" [class.is-active]="tab.Active" class="tab">
        <a>
          <span>{{tab.Title}}</span>
          @if (AllowDeleteRequest) {
            <span class="fa fa-trash inserticon" (click)="DeleteTab(i)"></span>
          }
          @if (AllowInsertRequest) {
            <span class="fa fa-plus inserticon" (click)="Insert(i)"></span>
          }
        </a>
      </li>
    }
    @if (AllowAddRequest) {
      <li class="tab" (click)="AddTab()">
        <a><span class="icon"><i class="fa fa-plus"></i></span><span>Add</span></a>
      </li>
    }
  </ul>
</div>
<div class="tab-body" [ngStyle]="{ 'height': HeightPercent + '%'}">
  <ng-content></ng-content>
</div>
